import { useState, useEffect } from 'react';

interface PdfComponents {
    DocumentComp: any;
    PageComp: any;
    isLoaded: boolean;
}

export const usePdfComponents = (): PdfComponents => {
    const [DocumentComp, setDocumentComp] = useState<any>(null);
    const [PageComp, setPageComp] = useState<any>(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Dynamic import only on client side to avoid SSR issues
        import('react-pdf')
            .then(mod => {
                // Configure PDF.js worker with secure HTTPS CDN
                mod.pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${mod.pdfjs.version}/pdf.worker.min.js`;

                // Set component references
                setDocumentComp(() => mod.Document);
                setPageComp(() => mod.Page);
                setIsLoaded(true);
            })
            .catch(error => {
                console.error('Failed to load react-pdf:', error);
            });
    }, []);

    return {
        DocumentComp,
        PageComp,
        isLoaded,
    };
};
